/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { Button } from '../Button/Button';
import { Hover } from '../Hover/Hover';
import { Icon, IconProps } from '../Icon/Icon';
import styles from './ButtonWithMenu.module.scss';

interface ButtonWithMenuI {
  className?: string;
  positionX?: 'left' | 'right';
  positionY?: 'top' | 'bottom';
  items?: ButtonWithMenuItem[];
}

export interface ButtonWithMenuItem {
  text: string;
  icon: IconProps['type'];
  onClick?: () => void;
  visible?: boolean;
}

export const ButtonWithMenu = ({
  className,
  positionX,
  positionY,
  items,
}: ButtonWithMenuI) => {
  const [isOpen, setIsOpen] = useState(false);

  const hoverRef = React.useRef<HTMLDivElement>(null);
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      buttonRef.current &&
      !buttonRef.current.contains(event.target as Node) &&
      hoverRef.current &&
      !hoverRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const renderItems = () => {
    if (!items) return null;

    return items
      .filter((item) => item.visible !== false)
      .map((item) => (
        <div
          key={`${item.icon}-${item.text}`}
          onClick={item.onClick}
          className={styles.item}
        >
          <Icon type={item.icon} />
          <div className={styles.text}>{item.text}</div>
        </div>
      ));
  };

  return (
    <div className={cn(styles.root, className)}>
      <Button
        ref={buttonRef}
        onClick={(event) => {
          event.stopPropagation();
          setIsOpen((prev) => !prev);
        }}
      >
        <Icon type="dots" />
      </Button>
      <Hover
        ref={hoverRef}
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        className={cn(styles.hover, styles[positionY], styles[positionX])}
      >
        <div className={styles.menu}>{renderItems()}</div>
      </Hover>
    </div>
  );
};
